import React from 'react';
import { Box } from '@mui/material';
import ReactJson, { InteractionProps } from 'react-json-view';
import TypographyComponent from '../TypographyComponent';

interface JsonEditorComponentProps {
  onChange: (val: object) => void;
  value: object;
}

const JsonEditorComponent = ({ onChange, value }: JsonEditorComponentProps) => {
  // const [jsonData, setJsonData] = useState<object>({});

  const handleChange = ({ updated_src }: InteractionProps) => {
    // setJsonData(updated_src);
    onChange(updated_src);
  };

  return (
    <Box sx={{ mb: 10 }}>
      <Box sx={{ mb: 2 }}>
        <TypographyComponent gutterBottom sx={{ fontWeight: 'bold' }}>
          Corpo da requisição
        </TypographyComponent>
      </Box>
      <ReactJson
        src={value}
        theme="monokai"
        name={false}
        displayObjectSize={false}
        collapsed={false}
        enableClipboard
        onEdit={handleChange}
        onAdd={handleChange}
        onDelete={handleChange}
      />
    </Box>
  );
};

export default JsonEditorComponent;
